import React from 'react';
import { ReclamationUI } from './ui';

export const ReclamationScreen: React.FC = (): JSX.Element => {
  return <ReclamationUI />;
};
